import React, {useCallback, useEffect} from "react";
import { connect } from "react-redux";
import {withRouter} from "react-router-dom";
import PropTypes from "prop-types";

import {
  setWizardActiveItem,
  setWizardActiveStep,
  setWizardSelectedValues
} from "../../../../../actions/wizardFunctions";
import {getActiveWizardItem} from "./lookWizardFunctions";
import {setLookCompatabilityAlert} from "../../../../../actions/lookFunctions";

import WithUpdateLookCartItem from "../../../hocs/withUpdateLookCartItem";
import LookWizardHooksProvider from "./lookWizardHooksProvider";


const LookWizard = (props) => {

  const {wizardList, location, setWizardActiveItem, wizardActiveItem, setWizardActiveStep, setWizardSelectedValues,
    children, lookCompatabilityAlert, setLookCompatabilityAlert, wizardActiveStep} = props;

  const closeCompatability = useCallback(() => {
    setLookCompatabilityAlert({
      visible: false,
      compatabilityLogic: [],
      clickedFeature: null,
      applyFunction: null
    })
  }, [setLookCompatabilityAlert])

  useEffect(() => {
    console.log("wizardActiveItem", wizardActiveItem);
    if (!wizardActiveItem) {
      const wizardItem = getActiveWizardItem(wizardList, location);
      console.log("wizardItem", wizardItem);
      if (wizardItem) {
        setWizardActiveItem(wizardItem)
      }
    }
    return () => {
      setWizardActiveItem(null);
      setWizardActiveStep(-1);
      setWizardSelectedValues({}, true);
      if (lookCompatabilityAlert && lookCompatabilityAlert.visible) {
        closeCompatability()
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [wizardList])

  useEffect(() => {
    if (lookCompatabilityAlert && lookCompatabilityAlert.visible) {
      closeCompatability()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [wizardActiveStep, wizardActiveItem]);

  if (!wizardActiveItem) {
    return null
  }

  return (
    <WithUpdateLookCartItem>
      {(updateLookCartItem) => (
        <LookWizardHooksProvider updateLookCartItem={updateLookCartItem}>
          {children}
        </LookWizardHooksProvider>
      )}
    </WithUpdateLookCartItem>
  )
};

LookWizard.propTypes = {
  children: PropTypes.oneOfType([PropTypes.func, PropTypes.node]).isRequired,
}

const mapStateToProps = (store) => {
  const {wizardList, wizardActiveItem, wizardActiveStep} = store.wizardState;
  const {lookCompatabilityAlert} = store.lookState;

  return {
    wizardList,
    wizardActiveItem,
    wizardActiveStep,
    lookCompatabilityAlert,
  };
};

const mapDispatchToProps = {
  setWizardActiveItem,
  setWizardActiveStep,
  setWizardSelectedValues,
  setLookCompatabilityAlert,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(LookWizard)
)
